module.exports = __webpack_public_path__ + "img/8a.d1d78a35.jpg";